/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { ENVIRONMENT_HELPER } from "@/helpers/environment.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const MESSAGES_SERVICE = {
    list,
    add,
    remove
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "Alerts";

/* Services */
function list()
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "GetAlerts"]);    
    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader()}
    };
    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions);
}

function add(text, userId) 
{
    // Mandatory parameters
    if(!text)
    {
        throw("The parameters are not complete!");
    }

    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "RegisterAlert"]); 
    
    let formData = new FormData();
    formData.append("text", text);
    if(userId)
    {
        formData.append("userId", userId);
    }

    const requestOptions = {
        method: 'POST',
        body: formData,
        headers: { ...authHeader() }
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions, false);
}

function remove(ids)
{
    // Mandatory parameters
    if(!ids || !Array.isArray(ids))
    {
        throw("The parameters are not complete!");
    }

    //

    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, 'RemoveAlerts']);    
    const requestOptions = {
        method: 'DELETE' ,
        body: JSON.stringify({ ids: ids }),
        headers: { ...authHeader(), 'Content-Type': 'application/json'}
    };

    // Process API call, validating the token beforehand.
    return API_HELPER.loggedApiCall(url, null, requestOptions, false);
}